const routes = [
  {
    path: 'store',
    name: 'store',
    redirect: '/store/list',
    component: () => import('@/views/store/index.vue'),
    meta: {
      name: '店铺'
    },
    children: [
      {
        path: 'list',
        name: 'storeList',
        component: () => import('@/views/store/pages/list.vue'),
        meta: {
          name: '店铺列表'
        }
      },
      {
        path: 'createStore',
        name: 'createStore',
        component: () => import('@/views/store/pages/createStore.vue'),
        meta: {
          name: '新建店铺'
        }
      },
      {
        path: 'storeDetail/:storeId',
        name: 'storeDetail',
        component: () => import('@/views/store/pages/storeDetail.vue'),
        meta: {
          name: '店铺详情'
        }
      }
    ]
  },
]
export default routes
